@import '../../assets/styles/components.css';

:host {
  @apply inline-flex leading-3;
  @apply flex-col gap-y-1;
  @apply w-48;
  @apply cursor-default;

  &([disabled]) {
    @apply pointer-events-none;

    abds-icon {
      @apply text-secondary-100;
    }
  }

  &([width='full']) {
    @apply w-full;
  }

  abds-label {
    @apply text-neutral-darkest;
  }

  .select-container {
    @apply relative;
    @apply text-secondary-400 text-sm;
    @apply cursor-pointer;

    abds-icon {
      @apply absolute top-0 bottom-0 right-2;
      @apply items-center;
      @apply pointer-events-none;
    }

    select {
      @apply duration-150 ease-out transition;
      @apply appearance-none outline-none;
      @apply leading-5 w-full;
      @apply overflow-hidden whitespace-nowrap overflow-ellipsis;
      @apply pl-2-border pr-8-border py-1.5-border;
      @apply border border-secondary-200 border-solid rounded;
      @apply text-neutral-dark bg-neutral-lightest;

      @apply hover:border-brand-600 cursor-pointer;
      @apply focus:border-brand-700 focus:ring focus:ring-primary-200;
      @apply disabled:bg-secondary-50 disabled:border-secondary-100 disabled:opacity-100 disabled:text-secondary-400;

      option {
        @apply text-neutral-dark bg-neutral-lightest;
        @apply not-italic text-sm;
        @apply disabled:text-secondary-100;
      }

      &:hover + abds-icon {
        @apply text-brand-600;
      }

      &.disabled-selected {
        @apply text-secondary-400;
      }

      &.placeholder {
        @apply italic;
      }
    }

    &.invalid {
      abds-icon {
        @apply text-danger-500;
      }

      select {
        @apply border border-danger-500 border-solid;
      }
    }
  }
}
